var _ = require('lodash');
var dd = require('react-dd');

var placeholder_value = '__some$random$uuid__';

var component = dd.createClass({
  __onChange: function(e){
    var field = this.props.field;
    var new_value = e.target.value;
    this.props.onChange(_.has(_.keyBy(field.options, "value"), new_value) ? new_value : null);
  },
  render: function(){
    var field = this.props.field;
    var options = _.keyBy(field.options, "value");
    var value = _.has(options, this.props.value) ? this.props.value : (field.placeholder ? placeholder_value : '');

    if(field.read_only){
      return dd.p({className: 'form-control-static'},
          _.has(options, value) ? _.get(options, [value, "label"]) : (value === placeholder_value ? null : value)
      );
    }

    return dd.select({
          name: field.name,
          value: value,
          onChange: this.__onChange,
          disabled: field.disabled ? 'disabled' : null,
          className: 'form-control' + (field.disabled ? ' disabled' : '')
        },
        _.has(field, ["placeholder"]) && dd.option({value: placeholder_value}, field.placeholder ? field.placeholder : ''),
        _.map(field.optgroups, function(optgroup, i){
            return dd.optgroup({key: i, label: optgroup},
              _.map(_.filter(field.options, function(option) {
                return _.get(option, ["optgroup"]) === optgroup;
              }), function(option) {
                return dd.option({value: _.get(option, ["value"]), key: _.get(option, ["value"])}, _.get(option, ["label"]));
              })
            );
        }),
        _.map(_.filter(field.options, function(option) {
          return !_.has(option, ["optgroup"]);
        }), function(option) {
          return dd.option({value: _.get(option, ["value"]), key: _.get(option, ["value"])}, _.get(option, ["label"]));
        })
    );
  }
});

module.exports = {
  component: component,
  validate: function(value, field){
    if(!_.has(field.options, value)){
      return 'Please make a selection';
    }
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/components/inputs/NewSelectInput.js